function addDropdownAttributeOnResize() {
        var elements = document.querySelectorAll('.nav-link.parent.has-children');

        function handleResize() {
                if (window.innerWidth > 992) {
                        elements.forEach(function (element) {
                                // element.classList.add('dropdown-toggle');
                                element.removeAttribute('data-bs-toggle');
                        });
                } else {
                        elements.forEach(function (element) {
                                // element.classList.remove('dropdown-toggle');
                                element.setAttribute('data-bs-toggle', 'dropdown');
                        });
                }
        }

        // Initial call to handleResize on page load
        handleResize();

        // Call handleResize on window resize event
        window.addEventListener('resize', handleResize);
}


function ready(callback) {
        // in case the document is already rendered
        if (document.readyState != 'loading') callback();
        // modern browsers
        else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
        // IE <= 8
        else document.attachEvent('onreadystatechange', function () {
                if (document.readyState == 'complete') callback();
        });
        addDropdownAttributeOnResize();
}

ready(function () {
        const productFormSelects = qsa('#AddToCartForm select');
        productFormSelects.forEach(function (select) {
                // console.log('label', label);
                if (select.hasAttribute('required')) {
                        label = getLabelForInput(select.id);
                        label.innerHTML += "<span class='required'>&nbsp;*</span>"
                }
        });

});

ready(function () {



        // window.addEventListener("resize", function () {
        //         "use strict"; window.location.reload();
        // });
        document.addEventListener("DOMContentLoaded", function () {
                /////// Prevent closing from click inside dropdown
                document.querySelectorAll('.dropdown-menu').forEach(function (element) {
                        element.addEventListener('click', function (e) {
                                e.stopPropagation();
                        });
                })
                // make it as accordion for smaller screens
                if (window.innerWidth < 992) {
                        // close all inner dropdowns when parent is closed
                        document.querySelectorAll('.navbar .dropdown').forEach(function (everydropdown) {
                                everydropdown.addEventListener('hidden.bs.dropdown', function () {
                                        // after dropdown is hidden, then find all submenus
                                        this.querySelectorAll('.submenu')
                                                .forEach(function (everysubmenu) {
                                                        // hide every submenu as well
                                                        everysubmenu
                                                                .style
                                                                .display =
                                                                'none';
                                                });
                                })
                        });
                        document.querySelectorAll('.dropdown-menu a').forEach(function (element) {
                                element.addEventListener('click', function (e) {
                                        let nextEl = this.nextElementSibling;
                                        if (nextEl && nextEl.classList
                                                .contains('submenu')) {
                                                // prevent opening link if link needs to open dropdown
                                                e.preventDefault();
                                                console.log(nextEl);
                                                if (nextEl.style.display ==
                                                        'block') {
                                                        nextEl.style.display =
                                                                'none';
                                                }
                                                else {
                                                        nextEl.style.display =
                                                                'block';
                                                }
                                        }
                                });
                        })
                }
                // end if innerWidth
        });
        // DOMContentLoaded  end


})      
